import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from 'src/app/modals/Authentication/auth.models';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './roles.action';

@Injectable({ providedIn: 'root' })
export class RolesTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                role_name: '', 
                amount_of_users: '', 
                access: null, //Null for select list
                created_at: '', 
            };

    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'role_name';
    initialSortDirection = 'asc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    accesses = [];
    hasFilter = false;
    columns = [
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date"},
                { prop: 'role_name', name: 'ROLES.role-name', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'amount_of_users', name: 'ROLES.amount-of-user', sortable: true, hasFilter: true, filter: "number"},
                { prop: 'access', name: 'ROLES.access', sortable: true, hasFilter: true, filter: "select", options: 'accesses', options_id: "id", options_label: "name" },
                { prop: 'actions', name: 'COMMON.actions', sortable: false, hasFilter: false, filter: ""},
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords());
    }

    hasActiveFilters(){

        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetFilters(){
        this.filters = {
            role_name: '', 
            amount_of_users: '', 
            access: null, 
            created_at: '', 
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;

        this.loadRecords();
    }

}